<template>
  <div id="app">
    <sui-loader
      v-show="generalFetching"
      size="large"
      class="general-loader"
      active
      centered
      inline
    />
    <transition
      enter-active-class="animated zoomCustomIn"
      leave-active-class="animated zoomCustomOut"
      mode="out-in"
    >
      <div v-show="!generalFetching">
        <router-view />
      </div>
    </transition>
    <search v-show="this.searchVisible" v-if="!generalFetching" />
    <menu-mobile
      v-show="menuMobileVisible && !generalFetching"
      :negative="menuMobileNegativeMode"
    />
  </div>
</template>

<script>
import "semantic-ui-css/semantic.min.css";

export default {
  name: "App",
  data() {
    return {
      searchVisible: false,
      menuMobileVisible: false,
      menuMobileNegativeMode: false,
      scrolled: false,
      languages: {
        "pt-BR": "pt",
        "en-US": "en",
        es: "es",
      },
    };
  },
  watch: {
    $route() {
      this.$store.dispatch("setContainerLocked", false);

      $(document).off("scroll");
      this.bindScroll();

      this.$hub.$off("hideSlider");
      this.menuMobileVisible = false;

      this.scrolled = false;

      setTimeout(() => {
        $("body, html").scrollTop(0);
      }, 400);
    },

    searchVisible(searchVisible) {
      const $body = document.body;

      if (searchVisible) {
        setTimeout(() => {
          $body.style.overflow = "hidden";
          $("html").css("margin-left", "calc(100vw - 100%)");
        }, 430);
        return;
      }

      $("html").css("overflow", "");
      $("html").css("margin-left", "");
      $body.style.overflow = "";
      $body.style.marginLeft = "";
    },
  },

  computed: {
    containerLocked() {
      return this.$store.state.ui.containerLocked;
    },

    generalFetching() {
      return this.$store.state.ui.loading;
    },
  },

  mounted() {
    // const browserLanguage = navigator.language || navigator.userLanguage;
    this.setLanguage("en");

    $("body, html").animate({ scrollTop: 1 });

    this.$hub.$on("setLanguage", (lang) => {
      this.setLanguage(lang);
    });

    this.$hub.$on("toggleSearch", () => {
      const windowWidth = $(window).width();

      this.searchVisible = !this.searchVisible;

      if (windowWidth >= 1000) {
        this.$hub.$emit("searchInputFocus");
      }
    });

    this.$hub.$on("toggleMenuMobile", this.toggleMenuMobile);

    setTimeout(() => {
      this.bindScroll();

      $(window).on("resize", () => {
        this.$hub.$emit("setPositionFooter");
      });
    }, 1000);
  },

  methods: {
    setLanguage(language = "en") {
      this.$store.dispatch("setLanguage", language);
      this.$i18n.locale = this.$store.state.ui.language;
      this.$hub.$emit("fixFilterLanguage");
      this.$hub.$emit("repeatRequests", language);
      this.$hub.$emit("resetFilters");
    },

    toggleMenuMobile(params) {
      if (!this.containerLocked) {
        this.scrolled = true;
        this.$hub.$emit("hideSlider");
      }

      this.menuMobileVisible = !this.menuMobileVisible;
      this.menuMobileNegativeMode = params?.negative || false;
    },

    bindScroll() {
      $(document).on("scroll", () => {
        const header = $(".home__fixed-container");
        if (header.length === 0) return;

        const headerPosition = $(".home__fixed-container").position().top - 300;
        const isPath = this.$route.path === "/";

        if (window.pageYOffset >= headerPosition && !this.scrolled && isPath) {
          this.scrolled = true;

          this.$hub.$emit("hideSlider");
        }
      });
    },
  },
};
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .general-loader {
    position: fixed !important;
    bottom: 0;
    margin: auto;
    right: 0;
  }

  .zoomCustomIn {
    -webkit-animation-name: zoomCustomIn;
    animation-name: zoomCustomIn;
    -webkit-animation-duration: 0.4s !important;
    animation-duration: 0.4s !important;
  }

  .zoomCustomOut {
    -webkit-animation-name: zoomCustomOut;
    animation-name: zoomCustomOut;
    -webkit-animation-duration: 0.4s !important;
    animation-duration: 0.4s !important;
  }
}
</style>
